import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const DevelopersSettingsView = React.lazy(
  () => import("./DevelopersSettings.view")
);

const DevelopersSettingsLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <DevelopersSettingsView />
  </React.Suspense>
);

export default () => <DevelopersSettingsLoadable />;
